export const CONSTANTS = {
    BUILDING_IMPROVEMENTS: "Building Improvements",
    FLEET_EQUIPMENT: "Fleet Equipment",
    LEASEHOLD_IMPROVEMENTS: "Leasehold Improvements",
    FURNITURE_FIXTURE_OFFICE_EQUIP: "Furniture/Fixtures/Office Equip",
    OWNED : "Owned",
    LEASED : "Leased",
    BULK_ORDER_GRID: "Bulk Order Grid",
    BULK_ORDER: "Bulk Order",
    KEY_FLEET_PROCESSING : "fleet-processing",
    ORDER_MANAGEMENT: "Order Management",
    ASSET_AUDIT_INVENTORY_MANAGEMENT: 'Asset Audit Inventory Management',
    SUPER_ADMIN: "Super-Admin",
    FLEET_ADMIN: "Fleet-Admin",
    EQUIPMENT_ORDERER: "Equipment-Orderer",
    FIXED_ASSET_ACCOUNTING : "Fixed Asset Accounting",
    SHARED_SERVICES: "Shared Services",
    LEADR_ORDER_NUMBER: "LEADR Order #",
    EMP_ID: "Employee #",
    JOB_ID: "Job #",
    EMP_NAME: "Employee Name",
    JOB_NAME: "Job Name",
    UNIT: "Unit#",
    ASSETS: "Assets#",
    DESCRIPTION: "Description",
    NEW_EMPLOYEE: "New Employee",
    NEW_BUSINESS: "New Business",
    PRODUCTION_VEHICLE: "Production Vehicle",
    MANAGEMENT_VEHICLE: "Management Vehicle",
    MANAGED_EQUIPMENT: "Managed Equipment",
    NON_STANDARD_EQUIPMENT: "Non-Standard Equipment",
    REASON_PLANNED: "Planned",
    REASON_UNPLANNED: "Unplanned",
    REASON_GROWTH: "Growth",
    IS_NEW_EMPLOYEE: "New Employee",
    ORDER_SUBMIT: "Submit",
    ORDER_SAVE: "Save",
    TITLE_SUCCESS: "SUCCESS",
    TITLE_CONFIRMATION: "CONFIRMATION",
    VAN: "Van",
    TRUCK: "Truck",
    TRAILER: "Trailer",
    SNOW: "Snow",
    TREE_CARE: "Tree Care",
    MOWER: "Mower",
    JOBTITLE: "Job Title",
    CONSTRUCTION_EQUIPMENT:"Construction Equipment",
    UTILITY_VEHICLE: 'Utility Vehicle',
    STANDARIZED_EQUIPMENT: 'Standardized Equipment',
    ATTACHMENTS_TOOLTIP_CONTENT: "Allowed file format are .xlsx, .xls, .doc, .docx, .odt, .ods, .ppt, .pptx, .pdf, .htm, .html, .jpeg, .jpg, .jpe, .jif, .jfif, .jfi, .png, .gif, .webp, .tiff, .tif, .psd. Upload files not more than 5MB",
    ATTACHMENTS_ACCEPT: ".xlsx,.xls,.doc,.docx,.odt,.ods,.ppt,.pptx,.pdf,.htm,.html,.jpeg,.jpg,.jpe,.jif,.jfif,.jfi,.png,.gif,.webp,.tiff,.tif,.psd",
    MANAGED_EQUIPMENT_REQUEST: "Managed Equipment Request",
    VEHICLE_REQUEST: "Vehicle Request",
    VEHICLE: "Vehicle",
    DEFAULT_ACCEPT: ".xlsx,.xls,.doc,.docx,.ppt,.pptx,.pdf,.jpeg,.jpg,.png",
    REPLACED_ASSET: "Replaced Asset #",
    REACTIVATION: "Reactivation",
    TRANSFER: "Transfer",
    DISPOSITION: "Disposition",
    AFEREQUEST: 'AFE Request',
    TRANSFER_REQUEST: "Transfer Request",
    DISPOSITION_REQUEST: "Disposition Request",
    REACTIVATION_REQUEST: "Reactivation Request",
    REQUISITION: "Requisition",
    REQUISITIONS: "Requisitions",
    ORDERDETAIL_VIEW: "orderdetail-view",
    APPROVAL_VIEW: "approval-view",
    SUCCESS: "success",
    FAILED: "failed",
    SELECT: "Select",
    DISPOSITION_CHOICES: {
        SELL_TO_LEASED: "Sell To, Leased",
        SELL_TO_OWNED: "Sell To, Owned",
        FMC_AUCTION_LEASED: "FMC Auction, Leased",
        FMC_AUCTION_OWNED: "FMC Auction, Owned",
        WRITE_OFF_LEASE_TRADE_IN: "Write-Off - Lease Trade In",
        WRITE_OFF_THEFT_LEASE_ASSET_NO_TITLE: "Write-Off (Theft/Insurance) Leased Asset (No Title/Registration)",
        WRITE_OFF_THEFT_OWNED_ASSET_NO_TITLE: "Write-Off (Theft/Insurance) Owned Asset (No Title/Registration)",
        WRITE_OFF_OWNED_ASSET_NO_TITLE: "Write-Off Owned Asset (No Title/Registration)",
        WRITE_OFF_LEASED_ASSET_NO_TITLE: "Write-Off Leased Asset (No Title/Registration) ",
        WRITE_OFF_THEFT_OWNED_ASSET_TITLED: "Write-Off (Theft/Insurance) Owned Asset (Titled/Registered)",
        WRITE_OFF_THEFT_LEASED_ASSET_TITLED: "Write-Off (Theft/Insurance) Leased Asset (Titled/Registered)",
        WRITE_OFF_OWNED_ASSET_TITLED: "Write-Off Owned Asset (Titled/Registered)",
        WRITE_OFF_LEASED_ASSET_TITLED: "Write-Off Leased Asset (Titled/Registered)",
        SELL_TO_LEASED_THIRD_PARTY: "Sell To, Leased - 3rd Party",
        SELL_TO_OWNED_THIRD_PARTY: "Sell To, Owned - 3rd Party",
        LEASE_RETURN: "Lease Return",
        SELL_TO_LEASED_IRON_PLANET: "Sell To, Leased - Iron Planet",
        SELL_TO_OWNED_IRON_PLANET: "Sell To, Owned - Iron Planet",
        JJ_KANE_EQUIPMENT_AUCTION: "JJ Kane Equipment Auction",
        EXMARK_LEASE_PROGRAM: "Exmark Lease Program",
        JJ_KANE_AUCTION: "JJ Kane Auction",
        WRITE_OFF_WITH_PROCEEDS_LEASED: "Write-Off with Proceeds (Leased)",
        WRITE_OFF_WITH_PROCEEDS_OWNED: "Write-Off with Proceeds (Owned)",
        PARTY_AUCTION_OWNED: "3rd Party Auction, Owned",
        PARTY_AUCTION_LEASED: "3rd Party Auction, Leased"

    },
    DISPOSITION_CHOICES_ATTACHMENT_NOTES: {
        WRITE_OFF_LEASE_TRADE_IN: "Signed Missing Asset Affidavit Must Be Attached",
        WRITE_OFF_THEFT_LEASE_ASSET_NO_TITLE: "Police Report Must Be Attached",
        WRITE_OFF_THEFT_OWNED_ASSET_NO_TITLE: "Police Report Must Be Attached",
        WRITE_OFF_OWNED_ASSET_NO_TITLE: "Signed Missing Asset Affidavit Must Be Attached",
        WRITE_OFF_LEASED_ASSET_NO_TITLE: "Signed Missing Asset Affidavit Must Be Attached",
        WRITE_OFF_THEFT_OWNED_ASSET_TITLED: "Police Report Must Be Attached",
        WRITE_OFF_THEFT_LEASED_ASSET_TITLED: "Police Report Must Be Attached",
        WRITE_OFF_OWNED_ASSET_TITLED: "Signed Missing Asset Affidavit Must Be Attached",
        WRITE_OFF_LEASED_ASSET_TITLED: "Signed Missing Asset Affidavit Must Be Attached",
        FMC_AUCTION_OWNED: "FMC Auction, Owned"

    },
    DISPOSITION_SUB_CHOICES: {
        THIRD_PARTY: "3rd Party"
    },
    TRANSFER_ASSET_RECEIVING_BRANCH_CHOICES: {
        DIVISION: "Division",
        COST_CENTER: "Cost Center",
        ASSIGNMENT_TRANSFER_TYPE: "Assignment Transfer Type"
    },
    ORDER_STATUS: {
        NEW: "New",
        SAVED: "Saved",
        SUBMITTED: "Submitted",
        PENDING_APPROVAL: "Pending Approval",
        FLEET_PROCESSING: "Fleet Processing",
        DENIED: "Denied",
        RETURNED: "Returned",
        RETURNED_TO_REQUESTOR: "Returned to Requestor",
        PROCESSING: "Processing",
        COMPLETED: "Completed",
        CANCELLED: "Cancelled",
        DELETED: "Deleted",
        UNSUBMITTED: "Unsubmitted",
        REJECTED: "Rejected",
        REQUISITION_COMPLETE: "Requisition Complete",
        TRANSFER_COMPLETE: "Transfer Complete",
        REACTIVATION_COMPLETE: "Reactivation Complete",
        AFE_COMPLETE: "AFE Complete",
        NBYA: "N/A",
        ASSIGNASSET: "Assign Asset#"
    },
    ITEM_STATUS: {
        ONE_WORLD_UPDATE : "One World Update",
        EONE_SET_UP: "EOne Set Up",
        SUBMITTED_TO_FLEET: "Submitted To Fleet",
        PO_CREATION: "PO Creation",
        FLEET_SETUP: "Fleet Setup",
        REQUISITION_COMPLETE: "Requisition Complete",
        CANCELLED: "Cancelled",
        SUBMITTED_TO_FINANCE: "Submitted To Finance",
        MISSING_DATA: "Missing Data",
        TRANSFER_COMPLETE: "Transfer Complete",
        DISPOSITION_COMPLETE: "Disposition Complete",
        REACTIVATION_COMPLETE: "Reactivation Complete",
        AFE_COMPLETE: "AFE Complete",
        FLEET_WEBCENTER: "Fleet WebCenter",
        UPFIT_PREPARATION: "Upfit Preparation",
        LEASE_SET_UP: "Lease Set-Up",
        PROCESS_COMPLETE: "Process Complete",
        PROGRAMS_UPDATE: "Programs Update",
        ASSET_REACTIVATION_SETUP: "Asset Reactivation Setup",
        NEW_FINANCE_ITEM: "New Finance Item",
        FUEL_CARD_TAG_AND_TITLE: "Fuel Card, Tag and Title",
        Receive_Bos_Payment: "Receive Bos, Payment",
        Receive_BOS_Payment: "Receive BOS, Payment",
        Receive_BosPayment: "Receive Bos,Payment",
        Receive_BOS_Payments: "Receive BOS,Payment",
        Receive_BOS: "Receive BOS",
        Receive_Payment: "Receive Payment",
        Branch_Verification: "Branch Verification",
        Missing_Data: "Missing Data",
        Costs_Payment_Title: "Costs, Payment, Title",
        Cost_Payment_Title: "Cost, Payment, Title",
        Receive_SOS_Payment: "Receive SOS/Payment",
        Pricing_Buyer_Info: "Pricing, Buyer Info",
        Unit_Termination: "Unit Termination",
        Title: "Title",
        Receive_BOS_Payment_Title: "Receive BOS, Payment, Title",
        Process_Title_Registration: "Process Title/Registration",
        Process_Title: "Process Title",
        WebCenter_Setup: "WebCenter Setup",
        Lease_Portfolio_Set_Up: "Lease Portfolio Set-Up",
        Order_Processing: "Order Processing",
        Fleet_WebCenter: "Fleet WebCenter",
        License_and_Title: "License & Title",
        Payment_Processing: "Payment Processing",
        Fixed_Asset_Queue: "Fixed Asset Queue",
        Pending: "Pending",
        Pending_Delivery: "Pending Delivery",
        Asset_Setup: "Asset Setup",
        Fuel_Card: "Fuel Card",
        Process_Complete: "Process Complete",
        Submitted_Finance: "Submitted Finance",
        Receive_Invoice: "Receive Invoice",
        Barcode_Assignment: "Barcode Assignment",
        Fuel_Card_Barcode_Assignment: "Fuel Card/Barcode Assignment",
        Asset_Master_Set_Up: "Asset Master Set-Up",
        Upfit_Preparation: "Upfit Preparation",
        Pending_Upfit_Completion : "Pending Upfit Completion",
        Fixed_Assets: "Fixed Assets",
        Fleet_Activity: "Fleet Activity",
        UNIT_Termination: "Unit Termination",
        FUEL_Card_Setup: "Fuel Card Setup",
        Carb_Setup: "Carb Setup",
        E1_Asset_Setup: "E1 Asset Setup",
        Transfer_State_Title: "Transfer State, Title",
        Costs_Term_Notice: "Costs, Term Notice",
        Pricing_Buyer_INFO: "Pricing, Buyer Info",
        Receive_Send_Term_Payment_Title: "Receive/Send Term, Payment, Title",
        E1_Update: "E1 Update",
        Send_Receive_Donation_Agreement: "Send/Receive Donation Agreement",
        Update_Registration: "Update Registration",
        E1_Receive_PO: "E1 Receive PO",
        Asset_Determination: "Asset # Determination",
        Asset_Reactivation_Setup: "Asset Reactivation Setup",
        SUBMITTED_to_FINANCE: "Submitted to Finance",
        Lease_Setup_Up : "Lease Setup-Up",
        New_Fleet_Item : "New Fleet Item",
        Receive_Term_Notice_Payment : "Receive Term Notice, Payment",
        AFE_Invoice_Review: "AFE Invoice Review"
    },
    DEALER_DETAILS: {
        ACTUAL_DELIVERY_DATE: "actualDeliveryDate",
        EST_DELIVERY_DATE: "estDeliveryDate",
        GL_ACCOUNT_NUMBER: "glaccountNumber",
        DEALER_NAME: "dealerName",
        DEALER_ADD1: "dealerAdd1",
        DEALER_ADD2: "dealerAdd2",
        DEALER_ADD3: "dealerAdd3",
        DEALER_STATE: "dealerState",
        DEALER_CITY: "dealerCity",
        DEALER_ZIP: "dealerZip",
        DEALER_EMAIL: "dealerContactEmail",
        PRICE_PER_UNIT: "pricePerUnit",
        DEALER_PHONE: "dealerPhone"
    },
    VENDOR_DETAILS: {
        VENDOR_NAME: "vendorName",
        VENDOR_ADD1: "vendorAdd1",
        VENDOR_ADD2: "vendorAdd2",
        VENDOR_STATE: "vendorState",
        VENDOR_CITY: "vendorCity",
        VENDOR_ZIP: "vendorZip",
        VENDOR_EMAIL: "vendorContactEmail",
    },
    TRAILERS: "Trailers",
    ASSET_DISPOSITION_NAME: "assetDispositionName",
    ASSET_DISPOSITION_ADDRESS1: "assetDispositionAddress1",
    ASSET_DISPOSITION_ADDRESS2: "assetDispositionAddress2",
    ASSET_DISPOSITION_ZIP: "assetDispositionZip",
    ASSET_DISPOSITION_REASON_CODE_DEFAULT_VALUE: "1",
    ASSET_LOCATION_NAME: "assetLocationName",
    ASSET_LOCATION_CONTACT_NAME: "assetLocationContactName",
    ASSET_LOCATION_EMAIL: "assetLocationEmail",
    ASSET_LOCATION_CONTACT_PHONE: "assetLocationContactPhone",
    ASSET_LOCATION_ADDRESS1: "assetLocationAddress1",
    ASSET_LOCATION_ADDRESS2: "assetLocationAddress2",
    ODOMETER_HOUR_METER: "odometerHourMeter",
    COLOR: "color",
    COMMENTS: "comments",
    CONDITIONAL_COMMENT: "conditionComment",
    PAGE_NAME: {
        REQUISITION: 'requisition',
        ASSET: 'asset'
    },
    ACTIVE_HEADER: {
        HOME: "Home"
    },
    ERROR_CODE : {
        STATUS_500: 500,
        STATUS_400: 400
    },
    GRID_ACTIVE_MENU: {
        TOTAL_ORDERS: 'Total Order',
        PENDING_APPROVAL: 'Pending Approval',
        FLEET_PROCESSING: 'Fleet Processing',
        COMPLETED: 'Completed',
        RETURNED: 'Returned',
        PENDING_FLEET_PROCESSING: 'Pending Fleet Processing',
        REJECTED: 'Rejected',
        CANCELLED: 'Cancelled',
        SAVED: 'Saved'
    },
    PURCHASE_TYPES: {
        CAPITAL_LEASE: "Capital Lease",
        OPERATING_LEASE: "Operating Lease",
        PURCHASE: "Purchase",
        DEFAULT_GL_ACCOUNT_NUMBER: "2311"
    },
    COMMON_ERROR: {
        EMPLOYEE_ID_NOT_VALID: "Employee ID is Invalid please try again"
    },
    FLEET_PROCESSING_TASKS: {
        ESTIMATED_DELIVERY_DATE: 'estimated delivery date',
        INVOICE_VOUCHERED : 'invoice vouchered - system updated',
        INVOICE_PAID : 'invoice paid - system updated'
    },
    CONSTRUCTION_EQUIPMENT_CATEGORY: {
        LOADER: "Loader",
        EXCAVATOR: "Excavator",
        SKID_STEER: "Skid Steer"
    },
    SNOW_CATEGORY: {
        PLOW: "Plow",
    },
    STANDARDIZED_EQUIPMENT_CATEGORY: {
        SKID_SPRAY_UNIT: "Skid Spray Unit",
        EDGERS: "Edgers",
        BLOWERS: "Blowers",
        AERATOR: "Aerator",
        OVERSEEDER: "Overseeder",
        LEAF_VAC: "Leaf Vac"
    },
    PO_STATUS: {
        IN_PROGRESS: "In Progress",
        COMPLETE: "Completed"
    },
    ADMIN: "Admin",
    ORDER_TYPE: {
        BAILMENT_POOL : "Bailment Pool",
        NA: "N/A"
     },
     LOCATION : {
        DIVISION: "Division",
        SUPER_REGION: "SuperRegion",
        REGION: "Region",
        MARKET: "Market",
        BRANCH: "Branch",
        COST_CENTER: "CostCenter"
     }, 
     REPORTS: {
        BARCODE_REPLACEMENT_REPORT: "Barcode Replacement Report",
        E1_UPLOAD_TEMPLATE: "E1 Upload Template"
     }
}

export const DATE_FORMAT = "MM/DD/YYYY";

export const  AttributeName = 
{
    DECKSIZE : "Deck Size",MODEL:"Model",
    VEHICLE_TYPE : "Vehicle Type",
    TRUCK_SIZE : "Truck Size",
    NO_OF_DOORS : "No. of Doors",
    MANUFACTURER : "Manufacturer",
    STATE_AVAILABILITY : "State Availability",
    PROGRAM_STATUS : "Program Status",
    ANNUAL_HOURS : "Annual Hours",
    DRIVE_TRAIN : "Drive Train",
    UPFIT_OPTION : "Upfit Option",
    SNOW_SETUP : "Snow Setup",
    FUEL_TYPE : "Fuel Type",
    CATEGORY: "Category",
    SEATING_CAPACITY: "Seating Capacity",
    LENGTH: "Length",
    CLASS_TYPE: "Class Type",
    BUDGETING_PERCENT: "Budgeting Percent",
    USEFUL_LIFE_LEASE_TERMS: "Useful Life / Lease Terms",
    GROUP_TYPE: "Group Type",
    VEHICLE_CLASS: "Vehicle Class",
    GROSS_WEIGHT_RATING: "Gross Vehicle Weight Rating",
    CDL_REQUIRED: "CDL Required",
    TRIM: "Trim",
    YEAR: "Year",
    MAKE: "Make",
    USE_TAG: "Use (Tags)",
    CATEGORY2: "Category 2",
    CATEGORY_TYPE: "Category Type",
    DECK_TYPE: "Deck Type",
    SIZE: "Size",
    AUTONOMOUS: "Autonomous",
    TYPE: "Type",
    ASSIGNMENT_GROUPS: "Assignment Groups",
    VEHICLE_LEVEL: "Vehicle Level",
    LOGOED: 'logoed',
    DRIVER_TITLE: 'Driver Title',
}

export const getNumberText = (number: any) => {
    const texts = [
        'Unknown',
        'First',
        'Second',
        'Third',
        'Fourth',
        'Fifth',
        'Sixth',
        'Seventh',
        'Eighth',
        'Ninth',
        'Tenth',
        'Eleventh',
        'Twelfth',
        'Thirteenth',
        'Fourteenth',
        'Fifteenth',
        'Sixteenth',
        'Seventeenth',
        'Eighteenth',
        'Nineteenth',
        'Twentieth',
    ];
    return texts[number] || 'Unknown';
};